import { z } from 'zod';

export const LineItemSchema = z.object({
  id: z.string().uuid(),
  area_id: z.string().uuid(),
  template_id: z.string().uuid().nullable(),
  cabinet_code: z.string().nullable(),
  description: z.string(),
  quantity: z.number().int().default(1),
  width: z.number().nullable(),
  height: z.number().nullable(),
  depth: z.number().nullable(),
  num_doors: z.number().int().default(0),
  num_drawers: z.number().int().default(0),
  num_shelves: z.number().int().default(0),
  box_material_id: z.string().uuid().nullable(),
  door_material_id: z.string().uuid().nullable(),
  drawer_front_material_id: z.string().uuid().nullable(),
  back_material_id: z.string().uuid().nullable(),
  shelf_material_id: z.string().uuid().nullable(),
  drawer_box_material_id: z.string().uuid().nullable(),
  finish_id: z.string().uuid().nullable(),
  finish_sqft_override: z.number().nullable(),
  construction_method_id: z.string().uuid().nullable(),
  construction_overrides: z.string().default('{}'),
  door_spec_code: z.string().nullable(),
  drawer_spec_code: z.string().nullable(),
  hinge_spec_code: z.string().nullable(),
  slide_spec_code: z.string().nullable(),
  pull_spec_code: z.string().nullable(),
  face_component_config: z.string().nullable(),
  frame_config: z.string().nullable(),
  banquette_config: z.string().nullable(),
  back_cushion_config: z.string().nullable(),
  hardware_config: z.string().nullable(),
  metal_base_config: z.string().nullable(),
  die_wall_config: z.string().nullable(),
  decorative_pillow_config: z.string().nullable(),
  position_x: z.number().default(0),
  position_y: z.number().default(0),
  position_z: z.number().default(0),
  is_in_3d_view: z.boolean().default(false),
  material_overrides: z.string().default('{}'),
  notes: z.string().nullable(),
  sort_order: z.number().int().default(0),
  exclude_labor: z.boolean().default(false),
  is_template: z.boolean().default(false),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateLineItemSchema = z.object({
  area_id: z.string().uuid().nullable().optional(),
  template_id: z.string().uuid().nullable().optional(),
  cabinet_code: z.string().nullable().optional(),
  description: z.string().min(1, 'Description is required'),
  quantity: z.number().int().default(1),
  width: z.number().nullable().optional(),
  height: z.number().nullable().optional(),
  depth: z.number().nullable().optional(),
  num_doors: z.number().int().default(0),
  num_drawers: z.number().int().default(0),
  num_shelves: z.number().int().default(0),
  box_material_id: z.string().uuid().nullable().optional(),
  door_material_id: z.string().uuid().nullable().optional(),
  drawer_front_material_id: z.string().uuid().nullable().optional(),
  back_material_id: z.string().uuid().nullable().optional(),
  shelf_material_id: z.string().uuid().nullable().optional(),
  drawer_box_material_id: z.string().uuid().nullable().optional(),
  finish_id: z.string().uuid().nullable().optional(),
  finish_sqft_override: z.number().nullable().optional(),
  construction_method_id: z.string().uuid().nullable().optional(),
  construction_overrides: z.string().default('{}'),
  door_spec_code: z.string().nullable().optional(),
  drawer_spec_code: z.string().nullable().optional(),
  hinge_spec_code: z.string().nullable().optional(),
  slide_spec_code: z.string().nullable().optional(),
  pull_spec_code: z.string().nullable().optional(),
  face_component_config: z.string().nullable().optional(),
  frame_config: z.string().nullable().optional(),
  banquette_config: z.string().nullable().optional(),
  back_cushion_config: z.string().nullable().optional(),
  hardware_config: z.string().nullable().optional(),
  metal_base_config: z.string().nullable().optional(),
  die_wall_config: z.string().nullable().optional(),
  decorative_pillow_config: z.string().nullable().optional(),
  position_x: z.number().default(0),
  position_y: z.number().default(0),
  position_z: z.number().default(0),
  is_in_3d_view: z.boolean().default(false),
  material_overrides: z.string().default('{}'),
  notes: z.string().nullable().optional(),
  sort_order: z.number().int().default(0),
  exclude_labor: z.boolean().default(false),
  is_template: z.boolean().default(false),
});

export const UpdateLineItemSchema = CreateLineItemSchema.partial();

export type LineItem = z.infer<typeof LineItemSchema>;
export type CreateLineItem = z.infer<typeof CreateLineItemSchema>;
export type UpdateLineItem = z.infer<typeof UpdateLineItemSchema>;
